import React from 'react';
import FormDateRangePicker from 'shared/inputs/datePickers/BaseDateRangePicker';

const UploadedOnControl = (props) => (
  <div className="control-wrapper">
    <FormDateRangePicker
      id="uploadedOn"
      className="flat-date-range"
      {...props}
    />
  </div>
);

export default UploadedOnControl;
